// extracted by mini-css-extract-plugin
module.exports =  {"ruler-button":"da51a739f7--ruler-button--BGj0G","pressed":"da51a739f7--pressed--MGZFY","icon":"da51a739f7--icon--KCdyX"};